module.exports = __webpack_public_path__ + "static/HarrietJohnsonTsui-a3c079f2a9fdb6c0aa3866962e2cf474.jpg";